import { toast } from "sonner";

export async function shareOrCopy({ title, text, url }) {
  const full = url ? `${text}\n${url}` : text;
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return;
    } catch (e) {
      if (e?.name === "AbortError") return;
    }
  }
  try {
    await navigator.clipboard.writeText(full);
    toast.success("Copié : collez-le dans votre messagerie");
  } catch {
    toast.error("Impossible de copier automatiquement");
  }
}

export const signed = (n) => (n > 0 ? `+${n}` : n < 0 ? `−${Math.abs(n)}` : "0");
